<template>
  <div class="about">
    <div class="title">
      <p class="en">ABOUT US</p>
      <p class="cn">{{$t("home.about.title")}}</p>
    </div>
    <div class="container">
      <div class="left">
        <div class="img">
          <img src="~assets/home/about.jpg"/>
        </div>
        <div class="ico">
          <img src="~assets/home/about-ico.png"/>
        </div>
      </div>
      <div class="right" v-html="$t('home.about.text')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  img
    width 100%
  .title
    width 100%
    text-align center
    padding-bottom 80px
    .en
      en()
      font-size 40px
    .cn
      cn()
      font-size 24px
  .about
    normalContainer()
    padding 83px 18.75% 192px
    background-image  url("~assets/home/about-bg.png")
    fullBg()
    .container
      flexCenter()
      .left
        position relative
        width 50%
        .img
          width 100%
        .ico
          position absolute
          right -43px
          bottom -50px
          width 90px
          height 70px
          z-index 2
      .right
        width 50%
        font-size 15px
        line-height 30px
        position relative
        left 45px
        font-weight bold
</style>



// WEBPACK FOOTER //
// src/pages/home/components/About.vue